import { KeycloakConfig } from "keycloak-js";

type KeycloakConfigStages = { pg: KeycloakConfig; qa: KeycloakConfig; prod: KeycloakConfig };

export const cockpitKeycloakConfig: KeycloakConfigStages = {
    pg: {
        url: "https://sso.pg.senecops.com",
        realm: "senec",
        clientId: "cockpit-frontend",
    },
    qa: {
        url: "https://sso.qa.senecops.com",
        realm: "senec",
        clientId: "cockpit-frontend",
    },
    prod: {
        url: "https://sso.senec.com",
        realm: "senec",
        clientId: "cockpit-frontend",
    },
};

export const controlKeycloakConfig: KeycloakConfigStages = {
    pg: {
        url: "https://sso.pg.senecops.com",
        realm: "senec",
        clientId: "control-frontend",
    },
    qa: {
        url: "https://sso.qa.senecops.com",
        realm: "senec",
        clientId: "control-frontend",
    },
    prod: {
        url: "https://sso.senec.com",
        realm: "senec",
        clientId: "control-frontend",
    },
};
